<template>
  <main>
    <b-navbar v-show="rootLevel" style="background: #fffbfe" type="light">
      <b-navbar-nav class="mx-auto">
        <b-nav-item
          :active="$route.name === 'application-access-manager-manage-access'"
          :to="{
            name: 'application-access-manager-manage-access',
          }"
          active-class="router-link-exact-active"
          class="navigation-item"
          >Manage Access
        </b-nav-item>
        <b-nav-item
          :active="$route.name === 'application-access-manager-view-all-requests'"
          :to="{
            name: 'application-access-manager-view-all-requests',
          }"
          active-class="router-link-exact-active"
          class="navigation-item"
          >View all requests
        </b-nav-item>
      </b-navbar-nav>
    </b-navbar>
    <router-view :user="user"></router-view>
  </main>
</template>

<script>
  export default {
    name: 'ApplicationAccessManager',
    props: {
      user: Object,
    },
    metaInfo() {
      let metaTitle = this.$appName + 'Application Access Manager';
      return {
        title: metaTitle,
      };
    },
    computed: {
      rootLevel() {
        return (
          this.$route.name.includes('manage-access') ||
          this.$route.name.includes('view-all-requests')
        );
      },
    },
  };
</script>
